/**
 * @fileoverview added by tsickle
 * Generated from: serializers/worker.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { dateField, dateTimeField, decimalField, modelSerializer, serializerField } from '../util/serializers';
import { areasByStrength, worker } from '../models/worker';
import { applicantSerializer } from './applicant';
import { housekeepDeviceSerializer } from './housekeep-device';
import { postcodeSerializer } from './postcode';
import { workerMetricsSerializer } from './worker-metrics';
import { metricsClassificationSerializer } from './worker-metrics-classification';
import { workerMoodSampleSerializer } from './worker-mood-sample';
/** @type {?} */
export var areasByStrengthSerializer = modelSerializer.extend({
    model: areasByStrength
});
/** @type {?} */
export var workerSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: worker,
    fields: {
        assigned_areas: (/** @type {?} */ (serializerField.create({
            serializer: areasByStrengthSerializer,
            optional: true
        }))),
        applicant: (/** @type {?} */ (serializerField.create({
            serializer: applicantSerializer,
            optional: true
        }))),
        postcode: (/** @type {?} */ (serializerField.create({
            serializer: postcodeSerializer,
            optional: true
        }))),
        housekeep_device: (/** @type {?} */ (serializerField.create({
            serializer: housekeepDeviceSerializer,
            optional: true
        }))),
        last_mood_sample: (/** @type {?} */ (serializerField.create({
            serializer: workerMoodSampleSerializer,
            optional: true
        }))),
        all_time_metrics: (/** @type {?} */ (serializerField.create({
            serializer: workerMetricsSerializer,
            optional: true
        }))),
        last_60_days_metrics: (/** @type {?} */ (serializerField.create({
            serializer: workerMetricsSerializer,
            optional: true
        }))),
        last_90_days_metrics: (/** @type {?} */ (serializerField.create({
            serializer: workerMetricsSerializer,
            optional: true
        }))),
        since_activation_metrics: (/** @type {?} */ (serializerField.create({
            serializer: workerMetricsSerializer,
            optional: true
        }))),
        metrics_classification: (/** @type {?} */ (serializerField.create({
            serializer: metricsClassificationSerializer,
            optional: true
        }))),
        started_work: dateField.create({ optional: true }),
        last_app_usage: dateTimeField.create({ optional: true }),
        created: dateTimeField.create({ optional: true }),
        modified: dateTimeField.create({ optional: true }),
        last_activation_dt: dateTimeField.create({ optional: true }),
        last_confirmation_dt: dateTimeField.create({ optional: true }),
        last_visit_date: dateTimeField.create({ optional: true }),
        pay_increase_date: dateField.create({ optional: true }),
        no_new_accounts_date: dateField.create({ optional: true }),
        admin_fee: decimalField.create({ optional: true }),
        base_pay: decimalField.create({ optional: true }),
        hourly_bonus: decimalField.create({ optional: true })
    }
})))));
